define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare, Controller) {

	return declare(Controller, {
		publish: function() {
			this.m_writer.noReturnNodes();
			this.m_writer.addParameter("OmitResults", "True");
			this.inherited(arguments);
		},

		postProcessSuccess: function() {
			this.widget.postActionRedraw(this);
		}
	});
});